import { useMemo } from "react";
import { useGoalsQuery } from "web_myplann/Api/Goals/useGoalsQuery";
import { formatDueIn } from "web_myplann/Goals/Helpers/formatDueIn";
import { mapGoalListItemDto } from "web_myplann/Goals/Mappers/mapGoalListItemDto";
import type { Goal } from "web_myplann/Goals/Types/GoalTypes";
import { GoalStateEnum } from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";

export const useActiveGoals = (): { goals: Goal[]; isPending: boolean } => {
	const { t } = useResource();
	const { data: goalsResponse, isPending } = useGoalsQuery([
		GoalStateEnum.Created,
		GoalStateEnum.Active,
	]);

	const goals = useMemo(
		() =>
			(goalsResponse?.data ?? []).map((dto) =>
				mapGoalListItemDto({ dto, dueIn: formatDueIn(dto.targetDate, t) }),
			),
		[goalsResponse, t],
	);

	return { goals, isPending };
};
